export const version = '2.21.5';
//# sourceMappingURL=version.js.map